import { render, staticRenderFns } from "./CofoundersEquity.vue?vue&type=template&id=46bbb680&scoped=true&"
import script from "./CofoundersEquity.vue?vue&type=script&lang=js&"
export * from "./CofoundersEquity.vue?vue&type=script&lang=js&"
import style0 from "./CofoundersEquity.vue?vue&type=style&index=0&id=46bbb680&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bbb680",
  null
  
)

export default component.exports